import { LOCATIONS_API } from "./CONSTANTS";
import customAxios from "./customAxios";

export const getZipCodeAddress = (zipCode: string) => {
  return new Promise((resolve, reject) => {
    try {
      customAxios
        .get(`${LOCATIONS_API}zipCodeAddress/${zipCode}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(new Error(err.message));
        });
    } catch (error) {
      reject(error);
    }
  });
};
